import { useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { AuthContext } from '../contexts/AuthContext';
import { useOktaAuth } from '@okta/okta-react';

const targets = {
  home: '/',
  unauthorized: '/unauthorized',
  forbidden: '/forbidden',
  page_not_found: '/pagenotfound',
};

function useNavigationLinks() {
  const navigate = useNavigate();
  const { sessionStore } = useContext(AuthContext);
  const { authState } = useOktaAuth();

  let isAuth = authState && authState?.isAuthenticated;

  const getURL = (key, params) => {
    let target = targets[key.toLowerCase()];
    if (typeof target !== 'string') {
      return '';
    }

    if (typeof params === 'object') {
      for (const prop in params) {
        if (Object.prototype.hasOwnProperty.call(params, prop)) {
          target = target.replace(`{${prop}}`, params[prop]);
        }
      }
    }
    return target;
  };

  const goHome = () => navigate('/');
  const goBack = () => navigate(-1);
  const goLogout = () => navigate('/');
  const goTo = (key, params) => {
    window.location.href = getURL(key, params);
  };
  const goToWithQueryParams = (key, params) => {
    window.location.href = `${getURL(key)}?${params.key}=${params.value}`;
  };

  return { getURL, goBack, goHome, goTo, goLogout, goToWithQueryParams };
}

export default useNavigationLinks;
